import { IconProps } from './index';

const BurgerMenu: React.VFC<IconProps> = ({ title, titleId, ...props }) => {
    return (
        <svg
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title && <title id={titleId}>{title}</title>}
            <path
                d="M0.125 0.833496L12.875 0.833496V2.25016L0.125 2.25016L0.125 0.833496ZM0.125 5.79183L12.875 5.79183L12.875 7.2085L0.125 7.2085L0.125 5.79183ZM0.125 10.7502L12.875 10.7502V12.1668L0.125 12.1668L0.125 10.7502Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default BurgerMenu;
